import React from 'react';
import ReactDOM from 'react-dom';
import { ListsComp } from './components/lists/lists.component';

const initListsComp = function (dom, data) {
  ReactDOM.render(<ListsComp data={data} />, document.getElementById(dom));
};

window.initListsComp = initListsComp;
